import { useEffect, useLayoutEffect, Suspense } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { publicRoutes, PrivateRoutes } from './routes';
import { scrollTo } from 'utils/scrollTo';
import { ROUTES } from 'utils/routeNames';
import PrivateRoute from './PrivateRoute';
import { useDispatch } from 'react-redux';
import { authActions } from 'store';
import { useFindSuccess } from 'hooks/useFindSuccess';
import { LOG_IN, SOCIAL_LOGIN } from 'store/auth';
import { isAuth } from 'utils/configs';
import { Header } from 'containers/Welcome/fragments/MainSection/core';
import { Footer } from 'components/common/Footer';
import { ScrollToTopButton } from 'components';
import styled from 'styled-components/macro';

const BaseRoutes = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const isSuccess = useFindSuccess(LOG_IN);
  const isSocialLoginSucess = useFindSuccess(SOCIAL_LOGIN);

  useEffect(() => {
    if (isSuccess.length || isSocialLoginSucess.length) {
      dispatch(authActions.userInfo());
    }
  }, [isSuccess.length, isSocialLoginSucess.length]);

  useEffect(() => {
    if (isAuth()) {
      dispatch(authActions.userInfo());
    }
  }, []);

  useLayoutEffect(() => {
    scrollTo(0, 0);
  }, [location]);

  return (
    <Suspense fallback="loading">
      <Header isAuth={isAuth} />
      <RoutContainer>
        <Routes>
          <Route path={ROUTES.INDEX}>
            {publicRoutes.map(({ id, component, path }) => (
              <Route key={id} element={component} path={path} />
            ))}

            {PrivateRoutes.map(({ id, component, path }) => (
              <Route
                key={id}
                element={<PrivateRoute>{component}</PrivateRoute>}
                path={path}
              />
            ))}
          </Route>
        </Routes>
      </RoutContainer>
      <Footer />
      <ScrollToTopButton />
    </Suspense>
  );
};

const RoutContainer = styled.div`
  min-height: calc(100vh - 232px);
`;

export default BaseRoutes;
